// ── LoanFundForm ──
import { useState, useEffect } from "react";
import { Btn, FInput, FInputNum, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const LoanFundForm = ({ initial, loanid, readOnly }) => {
    const { api, role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
    const [f, set] = useFreshForm(initial || {
      loanid: loanid || '', fundid: '', ownershippct: '', effectivedate: '', enddate: ''
    }, "LoanFunds");
    const [funds, setFunds] = useState([]);
    useEffect(() => {
      api.get('getFunds').then(d => setFunds(d.filter(f => f.status === 'Active'))).catch(() => setFunds([]));
    }, []);

    const fundOptions = [{ value: '', label: '— Select Fund —' }, ...funds.map(f => ({ value: f.id, label: f.fundname }))];

    return (
      <Modal
        title={readOnly ? 'View Fund Ownership' : initial ? 'Edit Fund Ownership' : 'Add Fund Ownership'}
        onClose={closeModal}
        onEdit={readOnly && role.canManageUsers ? () => { closeModal(); setModal({ type: 'loanfund-edit', rec: initial, loanid, onDone: modal.onDone }); } : null}
      >
        <ReadOnlyForm readOnly={readOnly}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 24px' }}>
            <Field label="Fund"><FSelect value={f.fundid || ''} onChange={set('fundid')} options={fundOptions} /></Field>
            <Field label="Ownership %">
              <FInputNum value={f.ownershippct} onChange={set('ownershippct')} placeholder="e.g. 100" />
            </Field>
            <Field label="Effective Date"><FInput type="date" value={f.effectivedate?.slice(0, 10) || ''} onChange={set('effectivedate')} /></Field>
            <Field label="End Date"><FInput type="date" value={f.enddate?.slice(0, 10) || ''} onChange={set('enddate')} /></Field>
          </div>
          <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 4 }}>
            Active ownership for this loan must total 100% or less. End prior ownership before adding new ownership if transferring between funds.
          </div>
        </ReadOnlyForm>
        {!readOnly && error && <div style={{ color: '#993C1D', fontSize: 12, marginBottom: 8, marginTop: 8 }}>{error}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
          <Btn onClick={closeModal}>{readOnly ? 'Close' : 'Cancel'}</Btn>
          {!readOnly && (
            <Btn disabled={saving} variant="primary"
              onClick={() => saveRec('saveLoanFund', { ...f, loanid: f.loanid || loanid },
                initial ? 'Edited' : 'Added', 'LoanFunds',
                (initial ? 'Updated' : 'Added') + ' fund ownership', modal.onDone)}>
              {saving ? 'Saving...' : 'Save'}
            </Btn>
          )}
        </div>
      </Modal>
    );
  };
